export default "__VITE_ASSET__053f4d91__"